import {SgfProducto} from "./../../_model/";
import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {config} from "environments/config";
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {UsuarioService} from '../usuario/usuario.service';
import {AlertService} from '../alert/alert.service';

@Injectable({
    providedIn: 'root'
})
export class SgfProductoService {
    user: any;

    constructor(private http: HttpClient,
                private userSrv: UsuarioService,
                private alertService: AlertService) {
    }


// -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    getProductos(token) {
        const params = new HttpParams().set("token", token);
        return this.http
            .post<any>(`${config.apiUrl}/producto`, params)
            .toPromise()
            .then((res) => <SgfProducto[]>res.data)
            .then((data) => {
                return data;
            })//.catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }


}
